import React from 'react'

export const BarcodeIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2H6.5V4H3V7.5H1V2ZM5.5 16.5L5.5 7.5H7.5L7.5 16.5H5.5ZM16.5 16.5V7.5H18.5V16.5H16.5ZM11 7.5V16.5H13V7.5H11ZM1 16.5V22H6.5L6.5 20H3L3 16.5H1ZM23 22H17.5V20H21V16.5L23 16.5V22ZM23 7.5V2H17.5V4L21 4V7.5L23 7.5Z"
        fill="#666666"
      />
    </svg>
  )
}

export default BarcodeIcon
